import React from 'react';
import { useIntl } from 'react-intl';
import { useHistory, useParams } from 'react-router';

import { useAccountState } from 'contexts/account/account-context';
import _ from 'underscore';

import FilterSidebar from 'components/filter-sidebar';
import Select from 'components/select';

import { Box, useTheme } from '@mui/material';
import Breadcrumbs from 'components/breadcrumbs';
import Paper from 'components/paper';
import RadioSelectItem from 'components/radio-select-item';
import EditSiteProfiles from 'views/profiles-strategies/features/site-profiles/components/edit-site-profiles';
import ProfilesStrategiesTabHeader from '../../components/profile-strategies-tabs-header';

type ParamTypes = {
  globalSiteId: string;
};

type Props = {};

const SiteProfiles: React.FC<Props> = () => {
  const theme = useTheme();
  const history = useHistory();
  const params = useParams<ParamTypes>();
  const { account } = useAccountState();
  const intl = useIntl();

  const PAGE_NAME_ID = 'profilesStrategies.editSiteProfiles';

  return (
    <>
      <ProfilesStrategiesTabHeader
        utils={
          <Breadcrumbs
            crumbs={
              !!params.globalSiteId
                ? [
                    {
                      text: String(account.company?.addressAccess.find((a) => a.id === params.globalSiteId)?.name),
                      url: params.globalSiteId,
                    },
                  ]
                : undefined
            }
          />
        }
      />
      <Paper transparent>
        <Box>
          <FilterSidebar>
            <Select
              label={intl.formatMessage({ id: `${PAGE_NAME_ID}.selectSite` })}
              value={params.globalSiteId ?? ''}
              onChange={(event) => history.push(`/profiles-strategies/site/${String(event.target.value)}`)}>
              {_.chain(account.company?.addressAccess)
                .sortBy((s) => s.name.toLowerCase())
                .value()
                .map((site) => (
                  <RadioSelectItem key={site.id} value={site.id} selected={site.id === params.globalSiteId}>
                    {site.name}
                  </RadioSelectItem>
                ))}
            </Select>
          </FilterSidebar>

          {!!params.globalSiteId && <EditSiteProfiles globalSiteId={params.globalSiteId} />}
        </Box>
      </Paper>
    </>
  );
};

export default SiteProfiles;
